const MODULE_NAME = 'hirlevelService';
import guid from '../../common/guid/guid';
class HirlevelService {
	constructor($http, environment, $q) {
		this._$http = $http;
		this._$q = $q;
		this._environment = environment;
		this._apiRoot = $http({
			url: `${environment.backendUrl}/do/proxy/b`
		});
	}
	kuldes(model, captcha) {
		let headers = {
			'x-captcha-id': this._captchaId,
			'x-captcha-value': captcha
		};
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$post('hirlevelFeliratkozas', null, model, { headers });
		}, () => {
			return this._$q.reject();
		});
	}
	getCaptchaUrl() {
		this._captchaId = guid();
		return `${this._environment.captchaUrl}/${this._captchaId}?appid=otpagrar`;
	}
	megerosites(token){
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$get('hirlevelMegerosites', {token});
		}, () => {
			return this._$q.reject();
		});
	}
	leiratkozas(token){
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$get('hirlevelLeiratkozas', {token});
		}, () => {
			return this._$q.reject();
		});
	}

}

HirlevelService.$inject = ['$http', 'environment', '$q'];
export default angular.module(MODULE_NAME, [])
	.service('hirlevelService', HirlevelService).name;



// WEBPACK FOOTER //
// ./source/applications/hirlevel/hirlevel-service.js